var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPot = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5013_214956)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 5.25172,
    fill: "#F4EFFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6693 51.2578C48.6693 52.0578 47.8693 54.8578 45.8693 55.6578C44.3689 56.2579 40.4061 58.3121 38.2693 59.4451L35.0693 59.2576C37.4693 57.5243 42.6693 53.8176 44.2693 52.8576C46.2693 51.6576 50.6693 47.6578 52.2693 47.2578C53.8693 46.8578 56.2693 47.6578 55.8693 48.4578C55.4693 49.2578 52.6693 50.4578 50.6693 51.2578Z",
    fill: "#FAE900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8693 59.6578C37.9938 59.5914 38.1275 59.5203 38.2693 59.4451M38.2693 59.4451C40.4061 58.3121 44.3689 56.2579 45.8693 55.6578C47.8693 54.8578 48.6693 52.0578 50.6693 51.2578C52.6693 50.4578 55.4693 49.2578 55.8693 48.4578C56.2693 47.6578 53.8693 46.8578 52.2693 47.2578C50.6693 47.6578 46.2693 51.6576 44.2693 52.8576C42.6693 53.8176 37.4693 57.5243 35.0693 59.2576L38.2693 59.4451Z",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3724 46.8578C45.0924 48.7778 43.1724 52.4578 42.3724 54.0578C40.6391 55.2578 37.2524 57.4178 37.5724 56.4578C37.9723 55.2578 41.9724 49.6576 42.3724 48.8578C42.7724 48.0579 45.5724 44.4578 45.9724 44.4578C46.3724 44.4578 47.9724 44.4578 46.3724 46.8578Z",
    fill: "#FAE900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3724 51.6578C37.1724 50.0578 40.3724 44.8578 41.5724 44.8578C42.7724 45.2578 40.7724 48.4578 39.9724 50.0578L36.3724 57.2578C34.7724 57.6578 31.8924 58.2978 33.1724 57.6578C34.7724 56.8578 35.5724 53.2578 36.3724 51.6578Z",
    fill: "#FAE900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3724 46.8578C45.0924 48.7778 43.1724 52.4578 42.3724 54.0578C40.6391 55.2578 37.2524 57.4178 37.5724 56.4578C37.9723 55.2578 41.9724 49.6576 42.3724 48.8578C42.7724 48.0579 45.5724 44.4578 45.9724 44.4578C46.3724 44.4578 47.9724 44.4578 46.3724 46.8578Z",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3724 51.6578C37.1724 50.0578 40.3724 44.8578 41.5724 44.8578C42.7724 45.2578 40.7724 48.4578 39.9724 50.0578L36.3724 57.2578C34.7724 57.6578 31.8924 58.2978 33.1724 57.6578C34.7724 56.8578 35.5724 53.2578 36.3724 51.6578Z",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0695 74.058C24.5095 76.618 20.1361 78.058 18.2693 78.458L16.4179 69.2C17.4846 68.2666 19.5994 67.2 21.2179 66C22.5427 65.0177 24.6694 63.6578 25.0694 62.0578C25.4694 60.4578 25.4694 56.0578 25.4694 54.4578C25.4694 52.8578 23.8694 50.0578 22.6694 48.8578C21.4694 47.6578 22.6694 46.4576 24.6694 46.8578C26.6694 47.2579 28.2694 49.2578 28.6694 50.8578C29.0694 52.4578 30.6694 55.6578 33.0694 56.0578C35.4694 56.4578 39.8694 53.6578 40.6694 52.8578C41.4694 52.0578 47.0694 48.4576 48.2694 47.2576C49.4694 46.0576 53.0694 45.2576 53.8694 46.4576C54.6694 47.6576 52.6694 48.0576 50.2694 49.6576C47.8694 51.2576 46.2694 53.6576 44.6694 55.2576C43.0694 56.8576 39.8694 60.4576 37.8694 62.8576C35.8694 65.2576 30.2695 70.858 27.0695 74.058Z",
    fill: "#FAE900",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-22.3247 76.6215C-12.3345 84.8347 -11.2475 89.4715 -11.2475 89.4715L19.1996 67.2C19.1996 67.2 22.9048 70.5025 29.4249 71.7729C11.6409 88.5619 -11.8427 118.782 -20.0549 117.388C-28.2671 115.994 -29.455 91.913 -29.1288 83.83C-28.8025 75.747 -32.4067 76.4398 -22.3247 76.6215Z",
    fill: "#5D21D2",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.3647,
    y: 43.9907,
    width: 54.9,
    height: 2.54118,
    rx: 1.27059,
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.8148 22.9766C26.1834 22.9766 15.9436 32.385 15.9436 43.9908H61.6859C61.6859 32.385 51.4462 22.9766 38.8148 22.9766Z",
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.8147,
    cy: 20.9968,
    r: 2,
    fill: "#B7C2FF",
    stroke: "#040222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5013_214956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 5.25172,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPot);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pot.2238346d422eb9c90854c92c63692313.svg";